<script setup lang="ts">
const { t } = useI18n();

const included = [
  { key: 'wifi',       icon: 'lucide:wifi' },
  { key: 'kitchen',    icon: 'lucide:utensils' },
  { key: 'linen',      icon: 'lucide:bed-double' },
  { key: 'starter',    icon: 'lucide:sparkles' },
  { key: 'day5Clean',  icon: 'lucide:calendar-check' },
  { key: 'access',     icon: 'lucide:waves' },
] as const;

const notIncluded = [
  { key: 'pool',      icon: 'lucide:droplets' },
  { key: 'parking',   icon: 'lucide:circle-parking' },
  { key: 'beachGear', icon: 'lucide:umbrella' },
  { key: 'midClean',  icon: 'lucide:spray-can' },
] as const;
</script>

<template>
  <section class="relative overflow-hidden pt-4 pb-10 md:pt-6 md:pb-16 bg-white dark:bg-slate-900">
    <div
      aria-hidden="true"
      class="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-amber-200/25 blur-3xl dark:bg-amber-500/10"
    />
    <div data-reveal class="relative container">
      <div class="grid gap-8 md:grid-cols-2">
        <!-- Included -->
        <div class="relative rounded-3xl border border-amber-200/70 dark:border-amber-900/60 bg-gradient-to-br from-amber-50/80 via-white to-amber-50/40 dark:from-amber-900/10 dark:via-slate-900 dark:to-slate-900 p-8 md:p-10">
          <div class="flex items-center gap-3">
            <span class="inline-flex size-8 items-center justify-center rounded-full bg-amber-400/80 text-slate-900">
              <Icon name="lucide:check" class="size-4" />
            </span>
            <p class="font-display italic text-xl md:text-2xl text-slate-900 dark:text-white">
              {{ t('prices.included.inTitle') }}
            </p>
          </div>
          <ul class="mt-8 space-y-5">
            <li
              v-for="item in included"
              :key="item.key"
              class="flex items-start gap-4 text-slate-800 dark:text-slate-100"
            >
              <Icon :name="item.icon" class="mt-1 size-5 shrink-0 text-amber-600 dark:text-amber-400" aria-hidden="true" />
              <span class="font-body text-base leading-relaxed">{{ t(`prices.included.in.${item.key}`) }}</span>
            </li>
          </ul>
        </div>

        <!-- Not included -->
        <div class="relative rounded-3xl border border-slate-200 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-900/40 p-8 md:p-10">
          <div class="flex items-center gap-3">
            <span class="inline-flex size-8 items-center justify-center rounded-full bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300">
              <Icon name="lucide:x" class="size-4" />
            </span>
            <p class="font-display italic text-xl md:text-2xl text-slate-900 dark:text-white">
              {{ t('prices.included.outTitle') }}
            </p>
          </div>
          <ul class="mt-8 space-y-5">
            <li
              v-for="item in notIncluded"
              :key="item.key"
              class="flex items-start gap-4 text-slate-700 dark:text-slate-200"
            >
              <Icon :name="item.icon" class="mt-1 size-5 shrink-0 text-slate-400 dark:text-slate-500" aria-hidden="true" />
              <span class="font-body text-base leading-relaxed">{{ t(`prices.included.out.${item.key}`) }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
